<template>
    <v-dialog
            v-model="authDialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            width="100%"
            content-class="mx-0"
    >
        <v-card>
            <v-toolbar
                    flat
                    dark
                    color="main--yellow"
            >
                <v-spacer></v-spacer>
                <v-btn icon @click="close">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <div class="d-flex justify-center text-center pa-4 grey--text lighten-2 title">
                {{ $t('actionRequireLogin') }}
            </div>
            <v-layout justify-center class="form-wrap">
                <v-card class="form-card">
                    <login-form @login-success="close"></login-form>
                </v-card>
            </v-layout>
        </v-card>
    </v-dialog>
</template>

<script>
    import LoginForm from '../../../app-front/components/forms/login-form';

    export default {
        name: "AuthDialog",
        props: ['isOpen'],
        components: {LoginForm},
        computed: {
            authDialog: {
                get() {
                    return this.isOpen;
                },
                set(value) {
                    if(!value) {
                        this.hideDialog();
                    }
                }
            }
        },
        methods: {
            close() {
                this.hideDialog();
            },
            hideDialog() {
                this.$store.commit('loginDialogHide');
            }
        },
        watch: {
            isOpen() {
                let url;

                if(this.isOpen) {
                    let query = window.location.search || '';
                    url = window.location.pathname + query;
                } else {
                    url = null;
                }

                this.$store.commit('updateBeforeLoginPath', url);
            }
        }
    }
</script>

<style scoped>

</style>
